import { render, staticRenderFns } from "./DataTableToimeksiantoKirje.vue?vue&type=template&id=66402058&scoped=true&"
import script from "./DataTableToimeksiantoKirje.vue?vue&type=script&lang=js&"
export * from "./DataTableToimeksiantoKirje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66402058",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66402058')) {
      api.createRecord('66402058', component.options)
    } else {
      api.reload('66402058', component.options)
    }
    module.hot.accept("./DataTableToimeksiantoKirje.vue?vue&type=template&id=66402058&scoped=true&", function () {
      api.rerender('66402058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataTableToimeksiantoKirje.vue"
export default component.exports